
<app-carousel-simple [shownCount]="settings?.showSize ?? '4'" [gap]="(settings.gap ?? 20)+'px'" #carousel>

    @for(article of articles; track article?.Url) {
        <a [routerLink]="article?.Url"
           ga4SelectPromotion
           ga4ViewPromotion
           [promotion_name]="article?.title">
           @if(article?.media != null) {
               <img [use]="article?.media"
               role="presentation"
               [size]="imgSize"
               aspect="1"
               [query]="{  rmode:'crop', rxy:'0.5,0.5' }"
               width="730">
            } @else {
                <svg width="730"
                     height="590"
                     role="presentation">
                    <rect width="730" height="590" fill="currentColor" />
                  </svg>
            }
            @if(article?.title != null && article?.title !== '') {
                <span class="title">{{ article?.title }}</span>
            }
            @else if(article?.pageTitle != null && article?.pageTitle !== '') {
                <span class="title">{{ article?.pageTitle }}</span>
            }
            @else {
                <span class="title">&nbsp;</span>
            }
        </a>
    } @empty {
        <span empty>{{ 'ARTICLES.EMPTY' | translate }}</span>
    }

</app-carousel-simple>
